// Search

export const SEARCH_REQUEST = 'SEARCH_REQUEST';
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS';
export const SEARCH_FAIL = 'SEARCH_FAIL';

// GET Customer Signature

export const GET_CUSTOMER_SIGNATURE_SUCCESS = 'GET_CUSTOMER_SIGNATURE_SUCCESS';

// Parts Seed Data

export const SEED_DATA_REQUEST = 'SEED_DATA_REQUEST';
export const SEED_DATA_SUCCESS = 'SEED_DATA_SUCCESS';
export const SEED_DATA_FAIL = 'SEED_DATA_FAIL';

// Inspection Post

export const ADD_INSPECTION_REQUEST = 'ADD_INSPECTION_REQUEST';
export const ADD_INSPECTION_SUCCESS = 'ADD_INSPECTION_SUCCESS';
export const ADD_INSPECTION_FAIL = 'ADD_INSPECTION_FAIL';
export const CLEAR_ADD_INSPECTION_STATES = 'CLEAR_ADD_INSPECTION_STATES';

// Inspection Listing

export const FETCH_INSPECTIONS_REQUEST = 'FETCH_INSPECTIONS_REQUEST';
export const FETCH_INSPECTIONS_SUCCESS = 'FETCH_INSPECTIONS_SUCCESS';
export const FETCH_INSPECTIONS_FAIL = 'FETCH_INSPECTIONS_FAIL';

// Get Inspection By ID

export const GET_INSPECTION_REQUEST = 'GET_INSPECTION_REQUEST';
export const GET_INSPECTION_SUCCESS = 'GET_INSPECTION_SUCCESS';
export const GET_INSPECTION_FAIL = 'GET_INSPECTION_FAIL';

// Inspection Deletion

export const DELETE_INSPECTION_REQUEST = 'DELETE_INSPECTION_REQUEST';
export const DELETE_INSPECTION_SUCCESS = 'DELETE_INSPECTION_SUCCESS';
export const DELETE_INSPECTION_FAIL = 'DELETE_INSPECTION_FAIL';

export const CLEAR_DELETE_INSPECTION_STATES = 'CLEAR_DELETE_INSPECTION_STATES';
// deleting inspection templates

export const DELETE_INSPECTION_TEMPLATE_REQUEST =
  'DELETE_INSPECTION_TEMPLATE_REQUEST';
export const DELETE_INSPECTION_TEMPLATE_SUCCESS =
  'DELETE_INSPECTION_TEMPLATE_SUCCESS';
export const DELETE_INSPECTION_TEMPLATE_FAIL =
  'DELETE_INSPECTION_TEMPLATE_FAIL';

// updating templates list after deleting
export const UPDATE_INSPECTION_TEMPLATE_LIST_ON_DELETE =
  'UPDATE_INSPECTION_TEMPLATE_LIST_ON_DELETE';

// clearing deleted inspection template state

export const CLEAR_DELETE_INSPECTION_TEMPLATE_STATES =
  'CLEAR_DELETE_INSPECTION_TEMPLATE_STATES';

// Create Custom Template

export const CREATE_CUSTOM_TEMPLATE_REQUEST = 'CREATE_CUSTOM_TEMPLATE_REQUEST';
export const CREATE_CUSTOM_TEMPLATE_SUCCESS = 'CREATE_CUSTOM_TEMPLATE_SUCCESS';
export const CREATE_CUSTOM_TEMPLATE_FAIL = 'CREATE_CUSTOM_TEMPLATE_FAIL';

// Update Custom Template

export const UPDATE_CUSTOM_TEMPLATE_REQUEST = 'UPDATE_CUSTOM_TEMPLATE_REQUEST';
export const UPDATE_CUSTOM_TEMPLATE_SUCCESS = 'UPDATE_CUSTOM_TEMPLATE_SUCCESS';
export const UPDATE_CUSTOM_TEMPLATE_FAIL = 'UPDATE_CUSTOM_TEMPLATE_FAIL';

// Get Custom Templates

export const GET_CUSTOM_TEMPLATES_REQUEST = 'GET_CUSTOM_TEMPLATES_REQUEST';
export const GET_CUSTOM_TEMPLATES_SUCCESS = 'GET_CUSTOM_TEMPLATES_SUCCESS';
export const GET_CUSTOM_TEMPLATES_FAIL = 'GET_CUSTOM_TEMPLATES_FAIL';

// Get Error Code Details

export const GET_ERROR_CODE_DETAILS_REQUEST = 'GET_ERROR_CODE_DETAILS_REQUEST';
export const GET_ERROR_CODE_DETAILS_SUCCESS = 'GET_ERROR_CODE_DETAILS_SUCCESS';
export const GET_ERROR_CODE_DETAILS_FAIL = 'GET_ERROR_CODE_DETAILS_FAIL';
export const CLEAR_GET_ERROR_CODE_DETAILS = 'CLEAR_GET_ERROR_CODE_DETAILS';

// clear custom template states
export const CLEAR_CUSTOM_TEMPLATE_STATES = 'CLEAR_CUSTOM_TEMPLATE_STATES';

// clear customer history

export const CLEAR_CUSTOMER_STATE = 'CLEAR_CUSTOMER_STATE';

// CLEARING CUSTOMER SEARCH RESULTS

export const CLEAR_CUSTOMER_SEARCH_RESULTS = 'CLEAR_CUSTOMER_SEARCH_RESULTS';
